export default {
  elements: document.querySelectorAll('.js-visibility-check'),
  observer: null,
  init() {
    if (!this.elements.length) return;
    this.initObserver();
  },
  initObserver() {
    const options = {
      root: document,
      rootMargin: '0px',
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.smr_eventbus.emit('observer:InView', entry.target);

          setTimeout(() => {
            entry.target.classList.add('is-visible');
            entry.target.classList.add('was-visible');
          }, 0);
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, options);

    this.elements.forEach((el) => {
      this.observer.observe(el);
    });

    window.smr_observer = this;
  },
  removeEl(el) {
    this.observer.unobserve(el);
    setTimeout(() => {
      el.classList.remove('is-visible');
    }, 1);
  },
};
